import { BsChevronDown } from "react-icons/bs";
import i18n from "src/core/configs/i18n";

export interface SelectProps
  extends React.InputHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: string[];
}
function Select({ label, options, ...props }: SelectProps) {
  return (
    <div className="grid grid-cols-1 gap-2">
      <label className="text-lg text-zinc600 font-arBold" htmlFor={label}>
        {label}
      </label>
      <div className="relative">
        <select
          className="py-[9px] w-full px-3 text-sm border-[#545F71] border rounded-[6px] font-ar text-zinc500 focus:outline-none focus:shadow-none appearance-none"
          {...props}
        >
          {options.map((item: string, index: number) => {
            return (
              <option value={item} key={`${item}-${index}`}>
                {item}
              </option>
            );
          })}
        </select>
        <BsChevronDown
          className={`absolute  ${
            i18n.language === "ar" ? "left-[14px]" : "right-[14px]"
          } top-[10px] text-zinc500`}
          size={24}
        />
      </div>
    </div>
  );
}

export default Select;
